import request from '../utils/request.js'
export function getAdvInfo(data){
  return request({
    url:'/api/v1/advance/info',
    method:'get',
    params:data
  })
}

// 获取代理客服二维码（ap_advance.kf_qrcode）
export function getAdvKfQrcode(data){
  return request({
    url:'/api/v1/advance/kfQrcode',
    method:'get',
    params:data
  })
}
export function getOauth(data){
  return request({
    url:'/api/v1/admin/getOauth',
    method:'post',
    headers: {
      isToken: false
    },
    data:data
  })
}

export function getTestOauth(){
  return request({
    url:'/api/v1/admin/getTestOauth',
    headers: {
      isToken: false
    },
    method:'get'
  })
}


export function getAdminInfoLogin(){
  return request({
    url:'/api/v1/admin/getAdminInfoLogin',
    method:'get',
  })
}

// 作者主页配置（登录态）
export function getKqsignConfig () {
  return request({
    url: '/api/v1/admin/kqsign/get',
    method: 'get'
  })
}

// 保存作者主页配置（登录态）
export function saveKqsignConfig (data) {
  return request({
    url: '/api/v1/admin/kqsign/save',
    method: 'post',
    data
  })
}

// 开启/关闭主页（仅 signs）
export function setKqsign (data) {
  return request({
    url: '/api/v1/admin/setKqsign',
    method: 'post',
    data
  })
}

// 个人设置（登录态）：获取
export function getAdminProfile () {
  return request({
    url: '/api/v1/admin/profile/get',
    method: 'get'
  })
}

// 个人设置（登录态）：保存
export function saveAdminProfile (data) {
  return request({
    url: '/api/v1/admin/profile/save',
    method: 'post',
    data
  })
}

// 作者主页信息（公开）
export function getAdminInfo(params){
  return request({
    url:'/api/v1/getAdmininfo',
    method:'get',
    params
  })
}

// 作者主页作品分页（公开）
export function getHomeBooksPage(params){
  return request({
    url:'/api/v1/getBookList',
    method:'get',
    params
  })
}

// 作者栏目列表
export function getMchMenuList(params) {
  return request({
    url: '/api/v1/getMchMenuList',
    method: 'get',
    params
  })
}

// 作者作品列表
export function getMchBookList(data) {
  return request({
    url: '/api/v1/getMchBookList',
    method: 'post',
    data
  })
}

// 作者主页扩展信息（需登录态）
export function getMchInfo(params) {
  return request({
    url: '/api/v1/getMchInfo',
    method: 'get',
    params
  })
}

/**
 * 创建栏目
 * @param channelName
 * @param channelImg
 * @returns {*}
 */
export function createMenu(data){
  return request({
    url:'/api/v1/admin/createMenu',
    method:'post',
    data:data
  })
}



// WEBPACK FOOTER //
// ./src/api/admin.js